import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Australian date format (DD/MM/YYYY). Accepts a Date, ISO string, or YYYY-MM-DD.
// Booking timestamps carry the clinic's WALL-CLOCK time (often labelled +00:00), so never let the browser
// timezone-shift them: format the literal date/time components the way the diary does (string slicing).
const ISO_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/;

export function fmtDate(input) {
  if (!input) return "";
  if (typeof input === "string") {
    const m = ISO_RE.exec(input);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    const d = new Date(input);
    return isNaN(d.getTime()) ? input : d.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" });
  }
  if (input instanceof Date && !isNaN(input.getTime())) return input.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" });
  return "";
}

// Australian date + time, e.g. 02/09/2026, 1:30 pm
export function fmtDateTime(input) {
  if (!input) return "";
  if (typeof input === "string") {
    const m = ISO_RE.exec(input);
    if (m && m[4]) {
      const h = parseInt(m[4], 10), mm = m[5];
      return `${m[3]}/${m[2]}/${m[1]}, ${h % 12 || 12}:${mm} ${h < 12 ? "am" : "pm"}`;
    }
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = new Date(input);
  if (isNaN(d.getTime())) return typeof input === "string" ? input : "";
  return d.toLocaleString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "numeric", minute: "2-digit" });
}
